module.exports = __webpack_public_path__ + "static/media/Feather.ca9ce9ff.ttf";